module.exports = __webpack_public_path__ + "img/tp1.9e29af4c.png";